
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";

import bannerImg from "../assets/images/donationimg.png";
import { apiUrl } from "../config/Config";

const Contribute = () => {
  const [activePhase, setActivePhase] = useState(1);
  const [phaseData, setPhaseData] = useState({ phase1: [], phase2: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const currentData = activePhase === 1 ? phaseData.phase1 : phaseData.phase2;

  useEffect(() => {
    const fetchContributions = async () => {
      try {
        const response = await axios.get(apiUrl + "getcontributions");

        if (response.data?.status !== "success") {
          throw new Error(
            response.data?.message || "Unable to fetch contributions"
          );
        }

        setPhaseData({
          phase1: response.data?.data?.phase1 || [],
          phase2: response.data?.data?.phase2 || [],
        });
      } catch (requestError) {
        console.error("Unable to fetch contributions", requestError);
        setError("Unable to load contributions. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchContributions();
  }, []);

  // =========================
  // FORMAT DATE
  // =========================
  const formatDateDDMMYYYY = (dateTime) => {
    if (!dateTime) return "";

    const date = new Date(dateTime.replace(" ", "T"));

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  // =========================
  // TOTAL
  // =========================
  const total = currentData
    .reduce(
      // (sum, item) => sum + Number(item?.contri_amount || 0),
      (sum, item) => sum + Number(item?.amount || 0),
      0
    )
    .toFixed(2);

  return (
    <>
      <Helmet>
        <title>Contribute | TheOmSaga</title>

        <meta
          name="description"
          content="View contributions made towards TheOmSaga."
        />
      </Helmet>

      {/* =========================================
          BANNER
      ========================================= */}
      <section className="home-main-sec donation-oage-banner">
        <img
          src={bannerImg}
          className="home-main-sec-bg "
          alt="Contribute Banner"
        />

        <div className="home-main-sec-overlay"></div>

        <div className="container home-main-sec-content">
          <h1 className="loop-title">
            Together We Make a Difference
          </h1>
        </div>
      </section>

      {/* =========================================
          CONTRIBUTION SECTION
      ========================================= */}
      <section className="donation-page-table-section">
        <div className="container">
          <p className="donation-page-table-title">
            Every Contribution Counts
          </p>
          {/* PHASE BUTTONS */}
          <div className="donation-page-phase-buttons">
            <button
              className={`donation-page-phase-btn ${
                activePhase === 1 ? "active" : ""
              }`}
              onClick={() => setActivePhase(1)}
            >
              Phase 1
            </button>

            <button
              className={`donation-page-phase-btn ${
                activePhase === 2 ? "active" : ""
              }`}
              onClick={() => setActivePhase(2)}
            >
              Phase 2
            </button>
          </div>

          {/* TABLE */}
          <div className="donation-page-table-wrapper">
            <table className="donation-page-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="4" className="donation-page-status">
                      Loading contributions...
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td
                      colSpan="4"
                      className="donation-page-status donation-page-status-error"
                    >
                      {error}
                    </td>
                  </tr>
                ) : currentData.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="donation-page-status">
                      No contributions found for Phase {activePhase}.
                    </td>
                  </tr>
                ) : (
                  currentData.map((item) => (
                    <tr key={`${item.source || "enrollment"}-${item.id}`}>
                      <td>{item?.username || "-"}</td>
                      <td className="donation-page-blur-text">
                        {item?.fullname || "-"}
                      </td>
                      <td>{formatDateDDMMYYYY(item?.created_at)}</td>
                      {/* <td>₹ {item?.contri_amount || "0"}</td> */}
                      <td>₹ {Number(item?.amount || 0).toFixed(2)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* TOTAL */}
          <p className="donation-page-total">
            Contributed amount so far : ₹ {total}
          </p>
        </div>
      </section>
    </>
  );
};

export default Contribute;
